export default {
  ACCOUNT_HAS_BEEN_ACTIVATED: 'KONTO ZOSTAŁO AKTYWOWANE',
  ACTION: 'AKCJA',
  ACTIONS: 'AKCJE',
  ACTION_ADD_NEW: 'DODAJ NOWY',
  ACTION_ADD_PAYMENT: 'DODAJ PŁATNOŚĆ',
  ACTION_ADD_PAYMENTS: 'DODAJ PŁATNOŚCI',
  ACTION_BACKUP: 'KOPIA ZAPASOWA',
  ACTION_CANCEL: 'ANULUJ',
  ACTION_CONFIGURATIONS: 'KONFIGURACJE',
  ACTION_CONNECTIONS: 'POŁĄCZENIA',
  ACTION_DELETE: 'USUŃ',
  ACTION_EDIT: 'EDYCJA',
  ACTION_MESSAGE: 'WYŚLIJ WIADOMOŚĆ',
  ACTION_PAYMENTS: 'PŁATNOŚCI',
  ACTION_SAVE: 'ZAPISZ',
  ACTION_SUCCESSFUL: 'ZAKUP UDANY',
  ACTION_SUCCESSFULLY: 'WYKONANO Z POWODZENIEM',
  ACTION_TRANSLATE: 'TŁUMACZ',
  ACTIVATE_ACCOUNT: 'AKTYWUJ KONTO',
  ACTIVATE_USER: 'WŁĄCZ UŻYTKOWNIKA',
  ACTIVE: 'AKTYWNY',
  ACTIVE_DECODERS: 'AKTYWNE DEKODERY',
  ACTIVE_USERS: 'AKTYWNI UŻYTKOWNICY',
  ADD_BY_MAC: 'DODAJ PRZEZ MAC',
  ADD_BY_PASSWORD: 'DODAJ PRZEZ HASŁO',
  ADD_FROM_LIST: 'DODAJ Z LISTY STALKER',
  ADD_NEW: 'DODAJ NOWY',
  ADMINS_CREATED: 'ADMINISTRATOR  STWÓRZ',
  ADMINS_EXPIRED: 'ADMINISTRATOR  PRZEDAWNIONY',
  ADMINS_NAME: 'IMIĘ',
  ADMINS_STATUS: 'STATUS',
  ADMIN_NOW: 'ADMINISTRATOR TERAZ',
  AGREE_ON: 'ZGADZAM SIĘ',
  ALL_RIGHTS_RESERVED: 'Wszystkie prawa zastrzeżone',
  AMOUNT: 'ILOŚĆ',
  AND: 'I',
  ASSIGN: 'PRZYDZIEL',
  ASSIGN_TO_DEALER: 'PRZYDZIELAĆ DO DILERA',
  AUTH_ALL_RIGHTS_RESERVED: 'Wszystkie prawa zastrzeżone',
  AUTH_ALREADY_MEMBER: 'JESTEŚ JUŻ ZAREJESTROWANY',
  AUTH_BRAND: 'TV24',
  AUTH_COMPANYNAME: 'NAZWA FIRMY',
  AUTH_CREATE_ACCOUNT: 'REJESTRACJA',
  AUTH_EMAIL: 'E-MAIL',
  AUTH_FIRSTNAME: 'PIERWSZE IMIĘ',
  AUTH_FORGOTTEN_PASSWORD: 'ZAPOMNIAŁEM HASŁA',
  AUTH_GET_PASSWORD: 'POBIERZ HASŁO',
  AUTH_LASTNAME: 'NAZWISKO',
  AUTH_LOGIN: 'LGOWANIE',
  AUTH_LOGIN_BUTTON: 'ZALOGUJ',
  AUTH_MAIL: 'E-MAIL',
  AUTH_NIP: 'NIP',
  AUTH_PASSWORD: 'HASŁO',
  AUTH_PASSWORD_ACTIVATE: 'KONTO AKTYWNE',
  AUTH_PASSWORD_REPEAT: 'POWTÓRZ HASŁO',
  AUTH_PHONE_NUMBER: 'NR TELEFONU',
  AUTH_SUBMIT_BUTTON: 'ZATWIERDŹ',
  AUTH_USERNAME: 'NAZWA UŻYTKOWNIKA',
  AUTORECHARGED: 'DOŁADUJ AUTOMATYCZNIE',
  AUTORECHARGE_AMOUNT: 'ILOŚĆ DOŁADOWAŃ',
  AUTO_EXPAND: 'AUTOODNAWIANIE',
  BCA: 'Bitcoin Portfel',
  BCK: 'Bitcoin Klucz',
  BCP: 'Bitcoin Pin',
  BITCOIN_PAYMENT_SUCCESSFULLY: 'PŁATNOŚĆ BITCOIN ZAKOŃCZONO SUKCESEM',
  BRAND: 'TV24',
  BUY_LICENSE: 'KUP LICENCJE',
  CHANGE_BALANCE: 'ZMIEŃ BALANS',
  CHECK_ALL_USERS: 'ZAZNACZ WSZYSTKICH',
  CLIENTS: 'KLIENCI',
  COMPANY_NAME: 'NAZWA FIRMY',
  CONNECTIONS_CHART: 'POŁĄCZENIA DEKODERÓW',
  COPY_TO_CLIPBOARD: 'KOPIUJ',
  COUNTRIES: 'KRAJE',
  COUNTRY: 'KRAJ',
  COUNTRYS: 'KRAJE',
  CREATED: 'UTWORZONY',
  CREATED_AT: 'DATA UTWORZENIA',
  CREATE_WALLET: 'UTWÓRZ PORTFEL',
  CUR: 'Waluta',
  CURRENCY: 'WALUTA',
  CURRENCY_ADD_VALUE: 'WALUTA DODAJ WARTOŚĆ',
  CUSTOM_PAYMENT: 'NIESTANDARDOWE PŁATNOŚCI',
  'Can not create account. Please check settings':
    'NIE MOŻNA UTWORZYĆ PORTFELA PROBLEM Z KONFIGURACJĄ',
  DASHBOARD_NOTIFICATION: 'POWIADOMIENIE',
  DASHBOARD_NOTIFICATION_NAME: 'POWIADOMIENIA',
  DASHBOARD_SERVER_NOTIFICATION: 'POWIADOMIENIA SERWEROWE',
  DATEPICKER_ADD_DATE: 'SELEKTUJ I DODAJ DATE',
  DEALERS: 'DILERZY',
  DEALER_NAME: 'NAZWA DILERA',
  DEALER_PAYMENTS: 'PŁATNOŚCI DILERA',
  DEALER_SETTLEMENTS: 'ROZLICZENIA DILERA',
  DECODER: 'DEKODER',
  DECODERS_AMOUNT: 'LIMIT DEKODERÓW',
  DECODERS_LIMIT: 'LIMIT',
  DECODER_ASSIGNED: 'PRZYDZIEL',
  DECODER_AUTORECHARGED_CHANGED: 'AUTO ODNAWIANIE STATUS ZMIENIONY',
  DECODER_CREATED: 'DEKODER DODANY',
  DECODER_DELETED: 'USUNIĘTE',
  DECODER_EXPIRED_AND_LACK_OF_FUNDS: 'DEKORER WYGASA I BRAK FUNDUSZY',
  DECODER_EXPIRES3: 'DEKODER WYGASA 3 DNI',
  DECODER_MAC_CHANGED: 'MAC ZMIENIONY',
  DECODER_MODEL: 'MODEL',
  DECODER_NAME: 'NAZWA',
  DECODER_NAME_CHANGED: 'NAZWA ZMIENIONA',
  DECODER_RECHARGED: 'DEKODER DOŁADOWANY',
  DECODER_SERIAL: 'NR SERYJNY',
  DECODER_STATUS_CHANGED: 'STATUS ZMIENIONY',
  DECODER_TARIFF_CHANGED: 'TARYFA ZMIENIONA',
  DELETE: 'USUŃ',
  DEX: 'Przypomnienia O Wyłączeniu Dekodera',
  DGN: 'Dodaj Dekoder Za Pomocą  Hasła',
  DOWNLOAD_CLIENT: 'POBIERZ PANEL',
  DTD: 'Dekoder Test (Ilość Dni)',
  Dashboard: 'STRONA GŁÓWNA',
  EDIT: 'EDYCJA',
  EMAIL: 'E-MAIL',
  EXCHANGE_RATE: 'KURS WYMIANY',
  EXPIRED_AT: 'DATA WAŻNOŚCI',
  EXPIRE_AT: 'DEKODER WYGASA',
  'Error with execute GET. (Decoder)': 'BŁĄD PRZY WYKONYWANIU GET. (DEKODER)',
  FDM: 'Front-End Domena',
  FIRST_NAME: 'IMIĘ',
  FTH: 'FTP host',
  FTL: 'FTP login',
  FTP: 'FTP hasło',
  FTS: 'FTP port',
  FTT: 'FTP ścieżka katalogu docelowego',
  Failed: 'Nie powiodło się',
  GENERATE_PASSWORD: 'GENERUJ HASŁO',
  GO_TO_LOGIN: 'PRZEJDZ DO LOGOWANIA',
  IF_YOU_CHANGE_TARIFF_U_LOOSE_CURRENT_DECODER_STATE:
    'ZMIANA PAKIETU WIĄŻE SIĘ Z UTRATĄ CZASU DLA OBECNEGO PAKIETU, CZY JESTEŚ PEWNY TEJ DECYZJI?',
  INACTIVE: 'NIEAKTYWNY',
  INACTIVE_DECODERS: 'NIEAKTYWNE DEKODERY',
  INACTIVE_USERS: 'NIEAKTYWNI UŻYTKOWNICY',
  IS_DEFAULT: 'CENY ADMIN',
  LANGUAGES: 'JĘZYKI',
  LAST_ACTIVE: 'O. AKTYWNY',
  LAST_NAME: 'NAZWISKO',
  LICENSE_KEY: 'KLUCZ LICENCJI',
  LICENSE_TYPE: 'WYBIERZ',
  'LOADING...': 'ŁADOWANIE...',
  LOGIN: 'LOGIN',
  'Log Out': 'WYLOGUJ',
  MAC_ADDRESS: 'ADRES MAC',
  MAIL: 'POCZTA',
  MENU_ADMINS: 'ADMIN',
  MENU_CLIENTS: 'KLIENCI',
  MENU_DASHBOARD: 'STRONA GŁÓWNA',
  MENU_DEALERS: 'DILERZY',
  MENU_DEALER_PAYMENTS: 'PŁATNOŚCI DILERA',
  MENU_DECODERS: 'DEKODERY',
  MENU_GET_BACKUP: 'POBIERZ BAZĘ DANYCH',
  MENU_LABELS: 'ETYKIETY',
  MENU_LANGUAGES: 'JĘZYKI',
  MENU_LICENSE: 'LICENCJA',
  MENU_LICENSES: 'LICENCJE',
  MENU_LICENSE_PRICE_LIST: 'LISTA CEN LICENCJI',
  MENU_NOTIFICATIONS: 'POWIADOMIENIA',
  MENU_PAYMENTS: 'PŁATNOŚCI',
  MENU_PRICE_LISTS: 'CENNIK',
  MENU_PRICE_LISTS_GROUPS: 'GRUPY LISTY CEN',
  MENU_RECHARGE: 'DOŁADOWANIA',
  MENU_SETTINGS: 'USTAWIENIA',
  MENU_TEMPLATES: 'SZABLONY',
  MENU_TRANSACTIONS: 'TRANSAKCJE',
  MENU_TRANSLATIONS: 'TŁUMACZENIA',
  MENU_USER_PAYMENTS: 'PŁATNOŚCI UŻYTKOWNIKA',
  MESSAGE: 'WIADOMOŚĆ',
  MESSAGE_SENT_SUCCESSFULLY: 'WIADOMOŚĆ WYSŁANO POPRAWNIE',
  MESSAGE_TO: 'WIADOMOŚĆ DO',
  METHOD: 'METODA',
  MODAL_CONFIRM: 'POTWIERDŹ',
  MODAL_DO_YOU_WANT_TO_DELETE: 'CHCESZ USUNĄĆ',
  MODAL_DO_YOU_WANT_TO_RECHARGE: 'POTWIERDŹ DOŁADOWANIE',
  MODAL_NO: 'ANULUJ',
  MODAL_YES: 'ZATWIERDŹ',
  MONTHS: 'MIESIĘCY',
  MY_PAYMENTS: 'MOJE PŁATNOŚCI',
  MY_SETTLEMENTS: 'MOJE ROZLICZENIA',
  NAME: 'IMIĘ',
  NOTIFICATION: 'POWIADOMIENIE',
  NOT_ACTIVE: 'NIE AKTYWNY',
  NO_DATA: 'BRAK DANYCH',
  NO_DECODERS: 'BRAK DEKODERÓW',
  NO_NOTIFICATIONS: 'BRAK POWIADOMIEŃ',
  NO_RESULTS: 'BRAK REZULTATÓW',
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  PARAMETER_NAME: 'NAZWA PARAMETRU',
  PARAMETER_VALUE: 'WARTOŚĆ PARAMETRU',
  PASSWORD: 'HASŁO',
  PASSWORD_GENERATED: 'HASŁO WYGENEROWANE',
  PASSWORD_REMINDER: 'PRZYPOMNIENIE HASŁA',
  PAYMENTS: 'PŁATNOŚCI',
  PAYMENTS_CHART: 'TABELA PŁATNOŚCI',
  PAYMENT_METHOD: 'METODA PŁATNOŚCI',
  PERIOD: 'OKRES',
  PERSON: 'OSOBA',
  PHONE_NUMBER: 'NR TELEFONU',
  PP: 'PAYPAL',
  PPI: 'PayPal Klient Id',
  PPS: 'PayPal Sekret',
  PRICE: 'CENA',
  'PRICE LISTS': 'CENNIK',
  PRICE_LIST_MONTHS: 'ILOŚĆ MIESIĘCY',
  PRICE_LIST_NAME: 'NAZWA CENNIKA',
  PRICE_LIST_PRICE: 'CENA',
  PRICE_PER_MONTH: 'CENA MIESIĘCZNA',
  PRIVACY_POLICY_header: 'POLITYKA PRYWATNOŚCI',
  PROFILE_BUTTON_SAVE: 'ZAPISASZ',
  PROFILE_CHANGE_PASSWORD: 'ZMIEŃ HASŁO',
  PROFILE_CONFIRMPASSWORD: 'POTWIERDŹ HASŁO',
  PROFILE_EMAIL: 'E-MAIL',
  PROFILE_FIRSTNAME: 'IMIĘ',
  PROFILE_LASTNAME: 'NAZWISKO',
  PROFILE_OLD_PASSWORD: 'STARE HASŁO',
  PROFILE_PASSWORD: 'HASŁO',
  PROFILE_PHONENUMBER: 'NR TELEFONU',
  PROFILE_USER_EDIT: 'EDYCJA PROFILU',
  'Please recharge your account balance.': 'DOŁADUJ SALDO!!!',
  QUANTITY_OF_AUTORECHARGE: 'ILOŚĆ AUTO DOŁADOWAŃ',
  RCB: 'Recaptcha back-end (Sekretny)',
  RCF: 'Recaptcha front-end (Klucz Strony)',
  'REALIZATION DATE': 'DATA REALIZACJI',
  REALIZED_AT: 'ZREALIZOWANY',
  REBOOT: 'RESTART URZĄDZENIA',
  REBOOTING_DECODER: 'RESTART DEKODERA',
  RECHARGE: 'DOŁADUJ',
  RECHARGE_AMOUNT: 'ILOŚĆ MIESIĘCY',
  RECHARGE_INFO: 'INFORMACJE O RACHUNKU',
  RECHARGE_MODAL_CONFIRM: 'DOŁADOWANIE DEKODERA',
  RECHARGE_PAY: 'PŁATNOŚCI DOŁADUJ',
  REDIRECT_LINK: 'PRZEJDZ DO LOGOWANIA',
  REFRESH: 'ODŚWIEŻ',
  'REGISTERED SUCCESFULLY': 'REJESTRACJA ZAKOŃCZONA POMYŚLNIE',
  REGISTER_SUCCEED: 'REJESTRACJA UDANA',
  REGISTER_SUCCESS: 'ZAREJESTROWANO',
  REMEMBER_TO_SAVE_PASSWORD: 'PAMIĘTAJ, ABY ZAPISAĆ HASŁO',
  REROLL: 'ROZWIŃ',
  RUS: 'Użytkownik Rejestracja',
  SEARCH_AND_SELECT: 'WYSZUKAJ I WYBIERZ',
  SEARCH_BY_DECODER_NAME: 'SZUKAJ PO NAZWIE DEKODERA',
  SEARCH_FOR: 'SZUKAJ',
  'SEARCH_FOR...': 'SZUKAJ...',
  SELECT_DEALER: 'WYBIERZ DILERA',
  SETTINGS_INSTRUCTION: 'INSTRUKCJA USTAWIEŃ',
  SHORTCUT: 'SKRÓT',
  STATUS: 'STATUS',
  STL: 'Stalker Nazwa Użytkownika',
  STP: 'Stalker Hasło',
  STU: 'Stalker URL',
  SUBJECT: 'TEMAT',
  TARIFF: 'TARYFA',
  TARIFF_TYPE: 'TYP TARYFY',
  TERMS_OF_SERVICE: 'WARUNKI USŁUGI',
  TEST: 'TEST',
  TOTAL_USERS: 'WSZYSCY UŻYTKOWNICY',
  TRANSACTIONS_AMOUNT: 'KWOTA TRANSAKCJI',
  TRANSACTIONS_DATE: 'DATA TRANSAKCJI',
  TRANSACTIONS_DEVICE: 'URZĄDZENIE TRANSAKCJI',
  TRANSACTIONS_MONTHS: 'ILOŚĆ MIESIĘCY',
  TRANSLATION_LANGUAGE: 'JĘZYK TŁUMACZENIA',
  TRANSLATION_NAME: 'NAZWA TŁUMACZENIA',
  TRANSLATION_SAVE: 'ZAPISZ TŁUMACZENIE',
  TRANSLATION_TRANSLATION: 'TŁUMACZENIE',
  TYPE: 'TYP',
  Test: 'Test',
  'USER ID': 'ID UŻYTKOWNIKA',
  USERS_ACTIVE: 'AKTYWNI UŻYTKOWNICY',
  USER_NAME: 'N. UŻYTKOWNIKA',
  USER_PAYMENTS: 'PŁATNOŚCI UŻYTKOWNIKA',
  USER_TRANSACTIONS: 'TRANSAKCJE UŻYTKOWNIKA',
  WALLET_ADDRESS: 'ADRES PORTFELA',
  WRAP: 'ZWIŃ',
  'Wrong PayPal configuration': 'PROBLEM Z KONFIGURACJĄ PAYPAL',
  'Wyśli do': 'WYŚLIJ DO',
  YEAR_AND_MONTH: 'ROK I MIESIĄC',
  YOUR_BALANCE: 'STAN KONTA',
  YOUR_PASSWORD_IS: 'TWOJE HASŁO',
  YOU_HAVE_NO_BITCOIN_WALLET_CREATE_NEW:
    'NIE MASZ JESZCZE PORTFELA BITCOIN, MOŻESZ GO UTWORZYĆ',
  YOU_HAVE_NO_POWER_HERE: 'BRAK UPRAWNIEŃ',
  'Your login was correct, but you are not allowed access anyway.': '',
  'Required permission': 'PROBLEM Z AUTORYZACJĄ',
};
